// extracted by mini-css-extract-plugin
export var section = "trusted-module--section--3uZn7";
export var storeLink = "trusted-module--storeLink--3yQbC";